module.exports = __webpack_public_path__ + "img/lunbo133.46c4722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo133.png
// module id = oOoC
// module chunks = 0